import React, {useState, useEffect, createRef, useRef} from 'react';
import {useDispatch, useSelector} from "react-redux";
import clsx from "clsx";
import {makeStyles} from "@mui/styles";
import {useHistory, useParams} from "react-router-dom";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import DeleteIcon from "@mui/icons-material/Delete";
import SettingsIcon from "@mui/icons-material/Settings";
import StyleIcon from '@mui/icons-material/Style';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListSubheader from '@mui/material/ListSubheader';
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {styled} from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import Icon from "@mui/material/Icon";
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from "@mui/material/Typography";
import Stack from '@mui/material/Stack';
import Button from "@mui/material/Button";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { v4 as uuidv4 } from 'uuid';
import WebFont from 'webfontloader';
import FormHelperText from "@mui/material/FormHelperText";
import CircularProgress from "@mui/material/CircularProgress";

import { Controller, useForm } from 'react-hook-form';
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";

import { useSnackbar } from 'notistack';

import Dialog from "@mui/material/Dialog";
import Divider from "@mui/material/Divider";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import AppBar from "@mui/material/AppBar";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import Chip from '@mui/material/Chip';
import MenuItem from '@mui/material/MenuItem';
import Autocomplete from "@mui/material/Autocomplete";

import {userDataUpdated} from "../store/userSlice";
import {getForm, addForm, updateForm, addTag} from "../store/formSlice";
import { useScreenshot } from 'use-react-screenshot';

import {isMobile} from 'is-mobile';

import Heading from "../components/Heading";
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import InputEmail from "../components/InputEmail";
import Name from "../components/Name";
import FirstName from "../components/FirstName";
import LastName from "../components/LastName";
import ShortText from "../components/ShortText";
import LongText from "../components/LongText";
import Submit from "../components/Submit";
import Empty from "../components/Empty";
import Paragraph from "../components/Paragraph";
import Number from "../components/Number";
import Date from "../components/Date";
import SingleChoice from "../components/SingleChoice";
import MultipleChoice from "../components/MultipleChoice";
import Dropdown from "../components/Dropdown";
import Hidden from "../components/Hidden";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import NativeSelect from "@mui/material/NativeSelect";
import InputLabel from "@mui/material/InputLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import ImageUploader from "../components/ImageUploader";
import {Templates} from "../components/Templates";
import recaptcha from "../recaptcha.png";

import {ColorSchemes} from "../components/ColorSchemes";

const API_BASE = window.location.hostname;

export const FontFamilies = {
    default: [
        'Arial',
        'Arial Black',
        'Avant Garde',
        'Bookman',
        'Brush Script MT',
        'Comic Sans MS',
        'Courier New',
        'Helvetica',
        'Georgia',
        'Garamond',
        'Palatino',
        'Tahoma',
        'Times New Roman',
        'Trebuchet MS',
        'Verdana'
    ],
    google: [
        'Lato',
        'Open Sans',
        'Raleway',
        'Roboto',
        'Inter',
    ]
}

const useStyles = makeStyles(theme => ({
    root: {},
    formList: {
        listStyleType: 'none',

        '& > li': {
          borderRadius: 5,
          position: 'relative',
        },

        '& > li .selectedControls': {
            display: 'none',
            position: 'absolute',
            left: '100%',
            top: '50%',
            transform: 'translateY(-50%)',

            '& > button': {
                color: '#fff',
                margin: '5px 0 5px 15px',

                '&.removeIcon': {
                    backgroundColor: '#d73027'
                },

                '&.settingsIcon': {
                    backgroundColor: '#757575'
                },

                '&.dragIndicator': {
                  opacity: 0.25,
                  color: '#757575',
                  backgroundColor: 'transparent',
                  position: 'absolute',
                  top: '50%',
                  left: '-43px',
                  transform: 'translateY(-50%)',
                }

            }

        },

        '& > li.selected': {
            boxShadow: '0 0 0 2px #0293e2',
        },

        '& > li.selected .selectedControls': {
            display: 'block',
        },

    },
    rightBar: {
        display: 'flex',
        height: '100%',
        position: 'fixed',
        right: 0,
        zIndex: 998
    },
    leftBar: {
        display: 'flex',
        height: '100%',
        position: 'fixed',
        left: 0,
        zIndex: 999
    },
    leftBarToggler: {
        position: 'absolute !important',
        top: 12,
        left: '100%',
        backgroundColor: '#fff !important',

        '&:focus': {
            borderRadius: '0 !important'
        },

    },
    rightBarToggler: {
        position: 'absolute !important',
        top: 12,
        right: '100%',
        backgroundColor: '#fff !important',

        '&:focus': {
            borderRadius: '0 !important'
        },

    },
    formWrapper: {
        display: 'flex',
        width: 'auto',
        justifyContent: 'center',

        '&.sendiio-form-family': {

            '&-roboto': {
                fontFamily: "'Roboto', sans-serif"
            },

            '&-open-sans': {
                fontFamily: "'Open Sans', sans-serif"
            },

            '&-lato': {
                fontFamily: "'Lato', sans-serif"
            },

            '&-inter': {
                fontFamily: "'Inter', sans-serif"
            },

            '&-raleway': {
                fontFamily: "'Raleway', sans-serif"
            },

        },

        '& .sendiio-form-type': {

            '&-emails': {

                '& .sendiio-element-type-number': {
                    display: 'none !important'
                }

            },

            '&-phone_numbers': {

                '& .sendiio-element-type-email': {
                    display: 'none !important'
                }

            }

        }

    },
    configuratorBtn: {
        backgroundColor: '#fff !important',
        position: 'fixed !important',
        right: 12,
        top: 72,
        zIndex: 0
    },
    logoFileName: {
        fontSize: "small",
        wordBreak: 'break-all',
        whiteSpace: 'break-spaces',
    },
    logo: {
        maxWidth: '100%',
        height: 'auto',
        padding: 0,
        margin: 0
    },
    recaptcha: {
        float: 'left',
        width: 300,
        height: 74,
        padding: 0,
        margin: '0 0 24px 0'
    },
    disabledDND: {
        opacity: 0.5
    },
    hideDND: {
        display: 'none',
    },
    listTag: {
        backgroundColor: 'transparent',
        transition: 'all 1s ease',

        '&.error': {
            backgroundColor: '#faeaea',
        },

        '&.success': {
            backgroundColor: '#ddeedd',
        },

    }
}));

const valueConditions = {
    equal: '<b>‘Equal’</b> setting means that whenever customer’s input will exactly match at least one of your predefined values, their email will be placed in selected tags.',
    not_equal: '<b>‘Not equal’</b> setting means that whenever customer’s input does not match any of your predefined values, their email will be placed in selected tags.',
    has_string: '<b>‘Has string’</b> setting means that whenever customer’s input will have at least one of text fragments predefined by you in values, their email will be placed in selected tags.',
    does_not_have_string: '<b>‘Does not have string’</b> setting means that whenever customer’s input will not have any of text fragments predefined by you in values, their email will be placed in selected tags.'
}

const leftDrawerWidth = 240;
const rightDrawerWidth = 320;

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        '& .MuiDrawer-paper': {
            position: 'relative',
            whiteSpace: 'nowrap',
            width: leftDrawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            boxSizing: 'border-box',
            ...(!open && {
                overflowX: 'hidden',
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                width: 56,
                [theme.breakpoints.up('sm')]: {
                    width: theme.spacing(7),
                },
            }),
        },
    }),
);

const RightDrawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        '& .MuiDrawer-paper': {
            zIndex: 1,
            position: 'relative',
            whiteSpace: 'nowrap',
            width: rightDrawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            boxSizing: 'border-box',
            ...(!open && {
                overflowX: 'hidden',
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                width: theme.spacing(0),
                [theme.breakpoints.up('sm')]: {
                    width: theme.spacing(0),
                },
            }),
        },
    }),
);

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: isDragging ? "orange" : "transparent",

    // styles we need to apply on draggables
    ...draggableStyle
});

const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "lightyellow" : "transparent",
    padding: grid,
    width: 'auto'
});

// a little function to help us with reordering the result
const reorderForm = (list, startIndex, endIndex) => {

    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const addToForm = (list, newElement, newIndex) => {

    const result = Array.from(list);

    // add unique ID
    result.splice(newIndex, 0, { ...newElement, id: uuidv4()});

    return result;

}

const removeFromForm = (list, id) => {

    const result = Array.from(list);

    const removeIndex = list.map(function(item) {return item.id; }).indexOf(id);

    result.splice(removeIndex, 1);

    return result;

}

const generateUniqueNumber = (n) =>  {
    let add = 1, max = 12 - add;   // 12 is the min safe number Math.random() can generate without it starting to pad the end with zeros.

    if ( n > max ) {
        return generateUniqueNumber(max) + generateUniqueNumber(n - max);
    }

    max        = Math.pow(10, n+add);
    const min    = max/10; // Math.pow(10, n) basically
    const number = Math.floor( Math.random() * (max - min + 1) ) + min;

    return ("" + number).substring(add);
}

export default function Form(props) {

    const { id } = useParams();

    const mobile = isMobile();

    let searchParams = new URLSearchParams((window.location.hash).replace('#/form?', ''));

    let colorScheme = searchParams.get("color");
    let template = searchParams.get("template");

    if(!colorScheme){
        colorScheme = 'white';
    }

    if(!template){
        template = 'default';
    }

    const history = useHistory();
    const classes = useStyles(props);

    const dispatch = useDispatch();

    const user = useSelector(({ credentials }) => credentials.userInfo);
    const userDataSelector = useSelector(({ userData }) => userData.userData);
    const [userDataState, setUserDataState] = useState(userDataSelector);

    // for tags
    const [useTags, setUseTags] = useState(false);
    const [formTags, setFormTags] = useState([]);
    const [tagsDialogOpened, setTagsDialogOpened] = useState(false);
    const [tagsUpdated, setTagsUpdated] = useState(false);
    const tagsListRefs = useRef([]);
    const tagsValuesRefs = useRef([]);

    const { enqueueSnackbar } = useSnackbar();

    const sendioFormRef = createRef(null);

    const [listType, setListType] = useState('emails');

    const [image, takeScreenshot] = useScreenshot();

    const [screenShooting, setScreenShooting] = useState(false);

    const [loading, setLoading] = useState(true);

    const [keepLogo, setKeepLogo] = useState(true);

    const [addNewTag, setAddNewTag] = useState(false);
    const [addingTag, setAddingTag] = useState(false);
    const [addTagData, setAddTagData] = useState(
        {
            'id': null,
            'name': ''
        }
    );

    const deletableElements = {
        email: true,
        name: false,
        firstname: false,
        lastname: false,
        short_text: false,
        long_text: false,
        hidden: false,
        number: true,
        data: false,
        single_choice: false,
        multiple_choice: false,
        dropdown: false,
        paragraph: false,
        submit: true
    }

    const [formElements, setFormElements] = useState([
            {
                id: uuidv4(),
                type: 'heading',
                content: 'Heading',
                icon: 'title',
                data: {
                    id: null,
                    type: 'heading',
                    title: 'Heading',
                    subtitle: '',
                    size: 'default',
                    textAlignment: 'left',
                },
                disabled: false,
            },
            {
                id: uuidv4(),
                type: 'email',
                content: 'Email',
                icon: 'email',
                data: {
                    id: null,
                    name: 'email',
                    type: 'email',
                    label: 'Email',
                    sublabel: 'example@example.com',
                    labelAlignment: 'top',
                    required: true,
                },
                disabled: true,
            },
            {
                id: uuidv4(),
                type: 'name',
                content: 'Name',
                icon: 'person',
                data: {
                    id: null,
                    name: `name`,
                    type: 'name',
                    label: 'Name',
                    sublabel: '',
                    labelAlignment: 'top',
                    required: true,
                },
                disabled: false,
            },
            {
                id: uuidv4(),
                type: 'firstname',
                content: 'First Name',
                icon: 'looks_one',
                data: {
                    id: null,
                    name: `first_name`,
                    type: 'firstname',
                    label: 'First Name',
                    sublabel: '',
                    labelAlignment: 'top',
                    required: true,
                },
                disabled: false,
            },
            {
                id: uuidv4(),
                type: 'lastname',
                content: 'Last Name',
                icon: 'looks_two',
                data: {
                    id: null,
                    name: `last_name`,
                    type: 'lastname',
                    label: 'Last Name',
                    sublabel: '',
                    labelAlignment: 'top',
                    required: true,
                },
                disabled: false,
            },
            {
                id: uuidv4(),
                type: 'short_text',
                content: 'Short Text',
                icon: 'input',
                data: {
                    id: null,
                    name: `short_text-${generateUniqueNumber(6)}`,
                    type: 'short_text',
                    label: 'Type a question',
                    sublabel: '',
                    labelAlignment: 'top',
                    required: true,
                },
                disabled: false,
            },
            {
                id: uuidv4(),
                type: 'long_text',
                content: 'Long Text',
                icon: 'text_snippet',
                data: {
                    id: null,
                    name: `long_text-${generateUniqueNumber(6)}`,
                    type: 'long_text',
                    label: 'Type a question',
                    sublabel: '',
                    labelAlignment: 'top',
                    required: true,
                },
                disabled: false,
            },
            {
                id: uuidv4(),
                type: 'hidden',
                content: 'Hidden',
                icon: 'visibility_off',
                data: {
                    id: null,
                    name: `hidden-${generateUniqueNumber(6)}`,
                    type: 'hidden',
                    value: '',
                    labelAlignment: 'top',
                    required: true,
                },
                disabled: false,
            },
            {
                id: uuidv4(),
                type: 'number',
                content: 'Phone Number',
                icon: 'looks_one',
                data: {
                    id: null,
                    name: 'number',
                    type: 'number',
                    label: 'Phone Number',
                    sublabel: '',
                    labelAlignment: 'top',
                    required: true,
                },
                disabled: true,
            },
            {
                id: uuidv4(),
                type: 'date',
                content: 'Date',
                icon: 'event',
                data: {
                    id: null,
                    name: `date-${generateUniqueNumber(6)}`,
                    type: 'date',
                    label: 'Date',
                    sublabel: '',
                    placeholder: 'DD-MM-YYYY',
                    labelAlignment: 'top',
                    required: true,
                },
                disabled: false,
            },
            {
                id: uuidv4(),
                type: 'single_choice',
                content: 'Single Choice',
                icon: 'radio_button_checked',
                data: {
                    id: null,
                    name: `single_choice-${generateUniqueNumber(6)}`,
                    type: 'single_choice',
                    label: 'Type a question',
                    options: [
                        'Type option 1',
                        'Type option 2',
                        'Type option 3',
                        'Type option 4',
                    ],
                    labelAlignment: 'top',
                    required: true,
                },
                disabled: false,
            },
            {
                id: uuidv4(),
                type: 'multiple_choice',
                content: 'Multiple Choice',
                icon: 'check_box',
                data: {
                    id: null,
                    name: `multiple_choice-${generateUniqueNumber(6)}`,
                    type: 'multiple_choice',
                    label: 'Type a question',
                    options: [
                        'Type option 1',
                        'Type option 2',
                        'Type option 3',
                        'Type option 4',
                    ],
                    labelAlignment: 'top',
                    required: true,
                },
                disabled: false,
            },
            {
                id: uuidv4(),
                type: 'dropdown',
                content: 'Dropdown',
                icon: 'arrow_drop_down_circle',
                data: {
                    id: null,
                    name: `dropdown-${generateUniqueNumber(6)}`,
                    type: 'dropdown',
                    label: 'Type a question',
                    sublabel: '',
                    options: [
                        'Type option 1',
                        'Type option 2',
                        'Type option 3',
                        'Type option 4',
                    ],
                    labelAlignment: 'top',
                    required: true,
                },
                disabled: false,
            },
            {
                id: uuidv4(),
                type: 'paragraph',
                content: 'Paragraph',
                icon: 'text_fields',
                data: {
                    id: null,
                    type: 'paragraph',
                    text: 'Click to edit this text',
                    size: 'default',
                    textAlignment: 'left',
                },
                disabled: false,
            },
            {
                id: uuidv4(),
                type: 'submit',
                content: 'Submit',
                icon: 'send',
                data: {
                    id: null,
                    name: `submit-${generateUniqueNumber(6)}`,
                    type: 'submit',
                    buttonText: 'Submit',
                    buttonAlignment: 'auto',
                },
                disabled: true,
            },
        ]);

    /**
     * Form Validation Schema
     */
    const schema = yup
        .object()
        .shape({
            name: yup.string().required('You must enter a form name!').min(5, 'Must be more then 5 symbols'),
            list_type: yup.string().required('List type is required!'),
            list_id: yup.number().nullable(true), //.required('Email list is required!'),
            phone_number_list_id: yup.number().nullable(true), //.required('Phone number list is required!'),
            callback_url: yup.string().required('You must enter a successfully subscribed url!').min(5, 'Must be more then 5 symbols'),
            already_subscribed_url: yup.string().required('You must enter a already subscribed url!').min(5, 'Must be more then 5 symbols'),
            use_captcha: yup.boolean().required('Use captcha is required!')
        })
        .required();

    const defaultValues = {
        name: 'My form',
        preview: null,
        logo: null,
        owner_id: user.owner_id,
        list_type: 'emails',
        list_id: null,
        phone_number_list_id: null,
        callback_url: '',
        already_subscribed_url: '',
        use_captcha: 0,
        json: {
            formWidthAuto: true,
            formWidth: 600,
            formColorScheme: colorScheme,
            formTemplate: template,
            formFontFamily: 'roboto',
            formLogo: {
                filename: '',
                width: null,
                height: null,
                alignment: 'center',
            },
            formContent: [
                {
                    "id": uuidv4(),
                    "type": "heading",
                    "title": "Heading",
                    "subtitle": "",
                    "size": "default",
                    "textAlignment": "left"
                },
                {
                    "id": uuidv4(),
                    "type": "email",
                    "name": 'email',
                    "label": "Email",
                    "sublabel": "example@example.com",
                    "labelAlignment": "top",
                    "required": true
                },
                {
                    "id": uuidv4(),
                    "type": "number",
                    "name": 'number',
                    "label": "Phone Number",
                    "sublabel": "",
                    "labelAlignment": "top",
                    "required": true
                },
                {
                    "id": uuidv4(),
                    "type": "submit",
                    "name": `submit-${generateUniqueNumber(6)}`,
                    "buttonText": "Submit",
                    "buttonAlignment": "auto"
                }
            ],
        },
        tags: [],
        views: 0,
        emails_lists_subscribes: 0,
        phone_numbers_lists_subscribes: 0
    }

    const { control, handleSubmit, setValue, getValues, formState: { errors } } = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(schema)
    });

    const onError = (errors, e) => {

        console.log(errors, e);

        handleOpenConfigurator(e, null);

    };

    // for leftbar
    const [open, setOpen] = useState(!mobile);

    const [formData, setFormData] = useState(defaultValues);

    const handleTagsChange = (e, index) => {

        let currentFormTags = [...formTags];

        const {target: { value }} = e;

        currentFormTags[index].tags = typeof value === 'string' ? value.split(',') : value;

        currentFormTags[index].tag_id = [];

        currentFormTags[index].tags.forEach((tag, i) => {

            currentFormTags[index].tag_id[i] = userDataState.tags.filter(item => item.name === tag)[0].id;

        });

        setFormTags(currentFormTags);

    };

    const handleCloseTagsDialog = () => {

        setTagsDialogOpened(false);

        setOpenConfigurator(true);

    }

    const handleOpenTagsDialog = () => {

        setTagsDialogOpened(true);

    }

    const handleUpdateFormData = (data) => {

        let currentForm = { ...formData };

        let itemIndex = currentForm.json.formContent.findIndex(item => item.id === data.id);

        currentForm.json.formContent[itemIndex] = data;

        setFormData(currentForm);

        //const conditions = ["single_choice", "multiple_choice", "dropdown"];
        //
        // const containsConditions = conditions.some(el => currentForm.json.formContent[itemIndex].type.includes(el));
        //
        // if(containsConditions){

            let currentFormTags = [...formTags];

            const elementName = currentForm.json.formContent[itemIndex].name;

            const elementOptions = currentForm.json.formContent[itemIndex].options;

            let index = currentFormTags.findIndex(item => {
                return item.input.includes(elementName);
            });

            if(index && index > 0){

                currentFormTags[index].options = elementOptions;

                setFormTags(currentFormTags);

            }

        // }

    }

    const handleUpdateLogoData = (data) => {

        let currentForm = { ...formData };

        currentForm.logo = data.image;
        currentForm.json.formLogo = {
            filename: data.filename,
            width: data.width,
            height: data.height,
            alignment: data.alignment,
        }

        setValue('logo', data.image);

        setKeepLogo(false);

        setFormData(currentForm);

    }

    const handleLabelsAlignment = (e) => {

        const target = e.target;
        let value = target.value;

        formData.json.formContent.forEach((item) => {

            if(item.labelAlignment){

                item.labelAlignment = value;

            }

        });

        setFormData({...formData});

    }

    const handleInputChange = (e, item) => {

        let currentForm = { ...formData };

        const target = e.target;
        let value = target.value;
        let name = target.name;

        if(!item){

            switch (name) {

                case 'list_type':

                    currentForm.list_type = value;

                    if(value === 'emails'){
                        currentForm.phone_number_list_id = null;
                    } else if(value === 'phone_numbers'){
                        currentForm.list_id = null;
                    }

                    break;

                case 'formLogoAlignment':

                    currentForm.json.formLogo.alignment = value;

                    break;

                case 'formWidthAuto':

                    currentForm.json.formWidthAuto = e.target.checked;

                    break;

                case 'formColorScheme':

                    currentForm.json[name] = value;

                    useColorScheme(value);

                    break;

                default:

                    currentForm.json[name] = value;

                    break;

            }

        } else {

            const index = currentForm.json.formContent.findIndex(element => element.id === item.id);

            if(name === 'required'){

                value = e.target.checked;

            }

            if(name === 'options'){

                value = value.split(/\r?\n|\r|\n/g);

            }

            currentForm.json.formContent[index][name] = value;

        }

        setFormData(currentForm);

    };

    // for configurator
    const configuratorRef = createRef();
    const [openConfigurator, setOpenConfigurator] = useState(!mobile);
    const [configuratorData, setConfiguratorData] = useState({
        'type': 'form',
        'itemID': null,
        'data': formData,
        'updateFormData': handleUpdateFormData
    });

    let activeConfiguratorItem = configuratorData.itemID;

    const handleOpenConfigurator = (e, item) => {

        setOpenConfigurator(true);

        // open form configurator
        if(!item){

            setConfiguratorData({
                'type': 'form',
                'itemID': item,
                'data': formData,
                'updateFormData': handleUpdateFormData
            });

        // open element configurator
        } else {

            setConfiguratorData({
                'type': 'item',
                'itemID': item,
                'data': formData
            });

        }

    };

    const toggleDrawer = () => {

        setOpen(!open);

    };

    const onDragEnd = (result) => {

        const { source, destination } = result;

        let currentForm = { ...formData };

        // dropped outside the list
        if (!result.destination) {
            return;
        }

        switch (source.droppableId) {

            case 'userForm':

                const items = reorderForm(
                    currentForm.json.formContent,
                    result.source.index,
                    result.destination.index
                );

                currentForm.json.formContent = items;

                setFormData(currentForm);

                break;

            case 'formElements':

                const newItems = addToForm(
                    currentForm.json.formContent,
                    formElements[source.index].data,
                    destination.index,
                );

                currentForm.json.formContent = newItems;

                setFormData(currentForm);

                break;


            default:

                    return false;

        }

        document.querySelectorAll('.sendiio-element').forEach((item) => {

            if(item.getAttribute('data-rbd-draggable-id') === result.draggableId){

                item.classList.add('selected');

            }

        });

        checkFormElements(currentForm);

    }

    const checkFormElements = (currentForm) => {

        let submitCounter = 0;
        let emailCounter = 0;
        let numberCounter = 0;

        currentForm.json.formContent.forEach((formItem) => {

            if(formItem.type === 'email'){
                emailCounter = emailCounter + 1;
            } else if(formItem.type === 'number'){
                numberCounter = numberCounter + 1;
            } else if(formItem === 'submit'){
                submitCounter = submitCounter + 1;
            }

        });

        formElements.forEach((formElement) => {

            if(formElement.type === 'submit' && submitCounter > 0){
                formElement.disabled = true;
            } else if(formElement.type === 'email' && emailCounter > 0){
                formElement.disabled = true;
            } else if(formElement.type === 'number' && numberCounter > 0){
                formElement.disabled = true;
            }

        });

        setFormElements(formElements);

    }

    const formElement = (item, useCaptcha) => {

        switch (item.type) {

            case "heading":

                return <Heading data={item} updateFormData={handleUpdateFormData} />;

            case "email":

                return <InputEmail data={item} updateFormData={handleUpdateFormData} />

            case "name":

                return <Name data={item} updateFormData={handleUpdateFormData} />

            case "firstname":

                return <FirstName data={item} updateFormData={handleUpdateFormData} />

            case "lastname":

                return <LastName data={item} updateFormData={handleUpdateFormData} />

            case "short_text":

                return <ShortText data={item} updateFormData={handleUpdateFormData} />

            case "long_text":

                return <LongText data={item} updateFormData={handleUpdateFormData} />

            case "hidden":

                return <Hidden data={item} updateFormData={handleUpdateFormData} />

            case "number":

                return <Number data={item} updateFormData={handleUpdateFormData} />

            case "date":

                return <Date data={item} updateFormData={handleUpdateFormData} />

            case "paragraph":

                return <Paragraph data={item} updateFormData={handleUpdateFormData} />

            case "single_choice":

                return <SingleChoice data={item} updateFormData={handleUpdateFormData} />

            case "multiple_choice":

                return <MultipleChoice data={item} updateFormData={handleUpdateFormData} />

            case "dropdown":

                return <Dropdown data={item} updateFormData={handleUpdateFormData} />

            case "submit":

                return <Submit data={item} updateFormData={handleUpdateFormData} />

            default:

                return null;

        }

    }

    const handleClickEmptyElement = () => {

        // console.log('test');

    }

    const handleRemove = (e, id) => {

        e.stopPropagation();

        let currentForm = { ...formData };

        const newItems = removeFromForm(currentForm.json.formContent, id);

        currentForm.json.formContent = newItems;

        setFormData(currentForm);

    }

    const addToFormManually = (item, index) => {

        let currentForm = { ...formData };

        const submitIndex = currentForm.json.formContent.findIndex(element => element.type === 'submit');

        const formLength = currentForm.json.formContent.length;

        const newItems = addToForm(
            currentForm.json.formContent,
            formElements[index].data,
            submitIndex >= 0 ? submitIndex : formLength,
        );

        currentForm.json.formContent = newItems;

        setFormData(currentForm);

        checkFormElements(currentForm);

    }

    const handleSelectElement = (e) => {

        if(!document.querySelector('.configuratorWrapper').contains(e.target)){

            document.querySelectorAll('.sendiio-element').forEach(item => {

                if(item.contains(e.target)){

                    item.classList.add('selected');

                } else {

                    item.classList.remove('selected');

                }

            });

            if(e.target.classList.contains('sendiio-form-wrapper')){

                setOpenConfigurator(false);

            }

            // const configuratorWrapper = document.querySelector('.configuratorWrapper');
            //
            // const saveFormBtn = document.querySelector('#saveForm');
            //
            // if(!configuratorWrapper.contains(e.target) && !saveFormBtn.contains(e.target)){
            //
            //     setOpenConfigurator(false);
            //
            // }

        }

    }

    const tagsInputOptions = (formTag, index) => {

        const inputs = [];

        let inputCounter = 0;

        let inputTagValuesArr = [];

        formData.json.formContent.forEach((item, itemIndex) => {

            let input = null;

            switch (item.type){

                case 'email':

                    if(formData.list_type === 'emails' || formData.list_type === 'both'){
                        //input = {name: 'Email', value: 'email'};
                    }

                    inputCounter++;

                    break;

                case 'number':

                    if(formData.list_type === 'phone_numbers' || formData.list_type === 'both'){
                        //input = {name: 'Phone Number', value: 'number'};
                    }

                    inputCounter++;

                    break;

                case "name":

                    input = {name: item.name, value: item.name};

                    inputCounter++;

                    break;

                case "firstname":

                    input = {name: item.name, value: `first_name`};

                    inputCounter++;

                    break;

                case "lastname":

                    input = {name: item.name, value: `last_name`};

                    inputCounter++;

                    break;

                case "short_text":

                    input = {name: item.name, value: item.name};

                    inputCounter++;

                    break;

                case "long_text":

                    input = {name: item.name, value: item.name};

                    inputCounter++;

                    break;

                case "single_choice":

                    input = {name: item.name, value: item.name};

                    inputTagValuesArr = item.options;

                    inputCounter++;

                    break;

                case "multiple_choice":

                    input = {name: item.name, value: item.name};

                    inputCounter++;

                    break;

                case "dropdown":

                    input = {name: item.name, value: item.name};

                    inputCounter++;

                    break;

                default:


                    break;

            }

            input && inputs.push(input);

        });

        return <Select
            labelId={`tags-label-input-${index}`}
            id={`tags-input-${index}`}
            value={formTag.input}
            label="Input Name"
            required
            onChange={(e) => {

                e.preventDefault();

                let currentFormTags = [...formTags];

                const elementID = e.target.value;

                currentFormTags[index].input = elementID;

                const conditions = ["single_choice-", "multiple_choice-", "dropdown-"];

                //const containsConditions = conditions.some(el => currentFormTags[index].input.includes(el));
                //
                //if(containsConditions){

                    let formDataElID = elementID;

                    let formDataEl = formData.json.formContent.filter(item => item.name === formDataElID)[0];

                    if(formDataEl){
                        currentFormTags[index].options = formDataEl.options;
                    } else {
                        currentFormTags[index].options = [];
                    }

                    currentFormTags[index].values = [];

                // } else {
                //
                //     currentFormTags[index].options = [];
                //
                // }

                setFormTags(currentFormTags);

            }}
        >
            {inputs.map((item, index) => (
                <MenuItem key={`tags-input-option-key-${index}`} value={item.value}>
                    {item.name}
                </MenuItem>
            ))}
        </Select>;

    }

    const elementConfigurator = (item) => {

        switch (item.type) {

            case 'heading':

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confHeadingTitle-${item.id}`}
                            name="title"
                            value={item.title}
                            type="text"
                            label="Heading Title"
                            id="headingTitle"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confHeadingSubtitle-${item.id}`}
                            name="subtitle"
                            value={item.subtitle}
                            type="text"
                            label="Heading Subtitle"
                            id="headingSubtitle"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`headingSize-${item.id}`}>Heading Size</InputLabel>
                        <NativeSelect
                            key={`confHeadingSize-${item.id}`}
                            name="size"
                            id="headingSize"
                            value={item.size}
                            label="Heading Size"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="small">Small</option>
                            <option value="default">Default</option>
                            <option value="large">Large</option>
                        </NativeSelect>
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`headingAlign-${item.id}`}>Text Alignment</InputLabel>
                        <NativeSelect
                            key={`confHeadingAlignment-${item.id}`}
                            name="textAlignment"
                            id="headingAlignment"
                            value={item.textAlignment}
                            label="Text Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="left">Left</option>
                            <option value="center">Center</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                </>

            case 'email':

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confEmailName-${item.id}`}
                            name="name"
                            value={item.name}
                            type="text"
                            label="Name"
                            id="emailName"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                            disabled
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confEmailLabel-${item.id}`}
                            name="label"
                            value={item.label}
                            type="text"
                            label="Label"
                            id="emailLabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confEmailSublabel-${item.id}`}
                            name="sublabel"
                            value={item.sublabel}
                            type="text"
                            label="Sublabel"
                            id="emailSublabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`labelAlignment-${item.id}`}>Label Alignment</InputLabel>
                        <NativeSelect
                            key={`confLabelAlignment-${item.id}`}
                            name="labelAlignment"
                            id="labelAlignment"
                            value={item.labelAlignment}
                            label="Label Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="top">Top</option>
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <FormControlLabel control={
                            <Checkbox checked={item.required}
                                      name="required"
                                      onChange={e => handleInputChange(e, item)} />
                        } label="Required" />
                    </FormControl>

                </>

            case 'name':

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confNameName-${item.id}`}
                            name="name"
                            value={item.name}
                            type="text"
                            label="Name"
                            id="nameName"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                            disabled
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confNameLabel-${item.id}`}
                            name="label"
                            value={item.label}
                            type="text"
                            label="Label"
                            id="nameLabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confNameSublabel-${item.id}`}
                            name="sublabel"
                            value={item.sublabel}
                            type="text"
                            label="Sublabel"
                            id="nameSublabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`labelAlignment-${item.id}`}>Label Alignment</InputLabel>
                        <NativeSelect
                            key={`confLabelAlignment-${item.id}`}
                            name="labelAlignment"
                            id="labelAlignment"
                            value={item.labelAlignment}
                            label="Label Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="top">Top</option>
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <FormControlLabel control={
                            <Checkbox checked={item.required}
                                      name="required"
                                      onChange={e => handleInputChange(e, item)} />
                        } label="Required" />
                    </FormControl>

                </>

            case 'firstname':

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confFirstnameName-${item.id}`}
                            name="name"
                            value={item.name}
                            type="text"
                            label="Name"
                            id="firstnameName"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                            disabled
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confFirstnameLabel-${item.id}`}
                            name="label"
                            value={item.label}
                            type="text"
                            label="Label"
                            id="firstnameLabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confFirstnameSublabel-${item.id}`}
                            name="sublabel"
                            value={item.sublabel}
                            type="text"
                            label="Sublabel"
                            id="firstnameSublabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`labelAlignment-${item.id}`}>Label Alignment</InputLabel>
                        <NativeSelect
                            key={`confLabelAlignment-${item.id}`}
                            name="labelAlignment"
                            id="labelAlignment"
                            value={item.labelAlignment}
                            label="Label Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="top">Top</option>
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <FormControlLabel control={
                            <Checkbox checked={item.required}
                                      name="required"
                                      onChange={e => handleInputChange(e, item)} />
                        } label="Required" />
                    </FormControl>

                </>

            case 'lastname':

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confLastnameName-${item.id}`}
                            name="name"
                            value={item.name}
                            type="text"
                            label="Name"
                            id="lastnameName"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                            disabled
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confLastnameLabel-${item.id}`}
                            name="label"
                            value={item.label}
                            type="text"
                            label="Label"
                            id="lastnameLabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confLastnameSublabel-${item.id}`}
                            name="sublabel"
                            value={item.sublabel}
                            type="text"
                            label="Sublabel"
                            id="lastnameSublabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`labelAlignment-${item.id}`}>Label Alignment</InputLabel>
                        <NativeSelect
                            key={`confLabelAlignment-${item.id}`}
                            name="labelAlignment"
                            id="labelAlignment"
                            value={item.labelAlignment}
                            label="Label Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="top">Top</option>
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <FormControlLabel control={
                            <Checkbox checked={item.required}
                                      name="required"
                                      onChange={e => handleInputChange(e, item)} />
                        } label="Required" />
                    </FormControl>

                </>

            case 'short_text':

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confShortTextName-${item.id}`}
                            name="name"
                            value={item.name}
                            type="text"
                            label="Name"
                            id="shortTextName"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confShortTextLabel-${item.id}`}
                            name="label"
                            value={item.label}
                            type="text"
                            label="Label"
                            id="shortTextLabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confShortTextSublabel-${item.id}`}
                            name="sublabel"
                            value={item.sublabel}
                            type="text"
                            label="Sublabel"
                            id="shortTextSublabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`labelAlignment-${item.id}`}>Label Alignment</InputLabel>
                        <NativeSelect
                            key={`confLabelAlignment-${item.id}`}
                            name="labelAlignment"
                            id="labelAlignment"
                            value={item.labelAlignment}
                            label="Label Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="top">Top</option>
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <FormControlLabel control={
                            <Checkbox checked={item.required}
                                      name="required"
                                      onChange={e => handleInputChange(e, item)} />
                        } label="Required" />
                    </FormControl>

                </>

            case 'long_text':

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confLongTextName-${item.id}`}
                            name="name"
                            value={item.name}
                            type="text"
                            label="Name"
                            id="longTextName"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confLongTextLabel-${item.id}`}
                            name="label"
                            value={item.label}
                            type="text"
                            label="Label"
                            id="longTextLabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confLongTextSublabel-${item.id}`}
                            name="sublabel"
                            value={item.sublabel}
                            type="text"
                            label="Sublabel"
                            id="longTextSublabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`labelAlignment-${item.id}`}>Label Alignment</InputLabel>
                        <NativeSelect
                            key={`confLabelAlignment-${item.id}`}
                            name="labelAlignment"
                            id="labelAlignment"
                            value={item.labelAlignment}
                            label="Label Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="top">Top</option>
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <FormControlLabel control={
                            <Checkbox checked={item.required}
                                      name="required"
                                      onChange={e => handleInputChange(e, item)} />
                        } label="Required" />
                    </FormControl>

                </>

            case 'hidden':

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confHiddenName-${item.id}`}
                            name="name"
                            value={item.name}
                            type="text"
                            label="Name"
                            id="hiddenName"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confHiddenValue-${item.id}`}
                            name="value"
                            value={item.value}
                            type="text"
                            label="Value"
                            id="hiddenValue"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                </>

            case 'number':

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confNumberName-${item.id}`}
                            name="name"
                            value={item.name}
                            type="text"
                            label="Name"
                            id="numberName"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                            disabled
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confNumberLabel-${item.id}`}
                            name="label"
                            value={item.label}
                            type="text"
                            label="Label"
                            id="numberLabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confNumberSublabel-${item.id}`}
                            name="sublabel"
                            value={item.sublabel}
                            type="text"
                            label="Sublabel"
                            id="numberSublabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`labelAlignment-${item.id}`}>Label Alignment</InputLabel>
                        <NativeSelect
                            key={`confLabelAlignment-${item.id}`}
                            name="labelAlignment"
                            id="labelAlignment"
                            value={item.labelAlignment}
                            label="Label Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="top">Top</option>
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <FormControlLabel control={
                            <Checkbox checked={item.required}
                                      name="required"
                                      onChange={e => handleInputChange(e, item)} />
                        } label="Required" />
                    </FormControl>

                </>

            case 'date':

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confDateName-${item.id}`}
                            name="name"
                            value={item.name}
                            type="text"
                            label="Name"
                            id="dateName"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confDateLabel-${item.id}`}
                            name="label"
                            value={item.label}
                            type="text"
                            label="Label"
                            id="dateLabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confDateSublabel-${item.id}`}
                            name="sublabel"
                            value={item.sublabel}
                            type="text"
                            label="Sublabel"
                            id="dateSublabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`labelAlignment-${item.id}`}>Label Alignment</InputLabel>
                        <NativeSelect
                            key={`confLabelAlignment-${item.id}`}
                            name="labelAlignment"
                            id="labelAlignment"
                            value={item.labelAlignment}
                            label="Label Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="top">Top</option>
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <FormControlLabel control={
                            <Checkbox checked={item.required}
                                      name="required"
                                      onChange={e => handleInputChange(e, item)} />
                        } label="Required" />
                    </FormControl>

                </>

            case 'single_choice':

                let singleOptions = '';

                item.options.forEach((option, index) => {

                    if(index === 0){
                        singleOptions = option;
                    } else {
                        singleOptions = `${singleOptions}\n${option}`;
                    }

                });

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confSingleChoiceName-${item.id}`}
                            name="name"
                            value={item.name}
                            type="text"
                            label="Name"
                            id="singleChoiceName"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confSingleChoiceLabel-${item.id}`}
                            name="label"
                            value={item.label}
                            type="text"
                            label="Label"
                            id="singleChoiceLabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confSingleChoiceOptions-${item.id}`}
                            multiline
                            rows={6}
                            name="options"
                            value={singleOptions}
                            type="text"
                            label="Options"
                            id="singleChoiceOptions"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`labelAlignment-${item.id}`}>Label Alignment</InputLabel>
                        <NativeSelect
                            key={`confLabelAlignment-${item.id}`}
                            name="labelAlignment"
                            id="labelAlignment"
                            value={item.labelAlignment}
                            label="Label Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="top">Top</option>
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <FormControlLabel control={
                            <Checkbox checked={item.required}
                                      name="required"
                                      onChange={e => handleInputChange(e, item)} />
                        } label="Required" />
                    </FormControl>

                </>

            case 'multiple_choice':

                let multipleOptions = '';

                item.options.forEach((option, index) => {

                    if(index === 0){
                        multipleOptions = option;
                    } else {
                        multipleOptions = `${multipleOptions}\n${option}`;
                    }

                });

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confMultipleChoiceName-${item.id}`}
                            name="name"
                            value={item.name}
                            type="text"
                            label="Name"
                            id="multipleChoiceName"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confMultipleChoiceLabel-${item.id}`}
                            name="label"
                            value={item.label}
                            type="text"
                            label="Label"
                            id="multipleChoiceLabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confMultipleChoiceOptions-${item.id}`}
                            multiline
                            rows={6}
                            name="options"
                            value={multipleOptions}
                            type="text"
                            label="Options"
                            id="multipleChoiceOptions"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`labelAlignment-${item.id}`}>Label Alignment</InputLabel>
                        <NativeSelect
                            key={`confLabelAlignment-${item.id}`}
                            name="labelAlignment"
                            id="labelAlignment"
                            value={item.labelAlignment}
                            label="Label Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="top">Top</option>
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <FormControlLabel control={
                            <Checkbox checked={item.required}
                                      name="required"
                                      onChange={e => handleInputChange(e, item)} />
                        } label="Required" />
                    </FormControl>

                </>

            case 'dropdown':

                let dropdownOptions = '';

                item.options.forEach((option, index) => {

                    if(index === 0){
                        dropdownOptions = option;
                    } else {
                        dropdownOptions = `${dropdownOptions}\n${option}`;
                    }

                });

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confDropdownChoiceName-${item.id}`}
                            name="name"
                            value={item.name}
                            type="text"
                            label="Name"
                            id="dropdownChoiceName"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confDropdownChoiceLabel-${item.id}`}
                            name="label"
                            value={item.label}
                            type="text"
                            label="Label"
                            id="dropdownChoiceLabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confDropdownSublabel-${item.id}`}
                            name="sublabel"
                            value={item.sublabel}
                            type="text"
                            label="Sublabel"
                            id="dropdownSublabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confDropdownChoiceOptions-${item.id}`}
                            multiline
                            rows={6}
                            name="options"
                            value={dropdownOptions}
                            type="text"
                            label="Options"
                            id="dropdownChoiceOptions"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`labelAlignment-${item.id}`}>Label Alignment</InputLabel>
                        <NativeSelect
                            key={`confLabelAlignment-${item.id}`}
                            name="labelAlignment"
                            id="labelAlignment"
                            value={item.labelAlignment}
                            label="Label Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="top">Top</option>
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <FormControlLabel control={
                            <Checkbox checked={item.required}
                                      name="required"
                                      onChange={e => handleInputChange(e, item)} />
                        } label="Required" />
                    </FormControl>

                </>

            case 'paragraph':

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confTextLabel-${item.id}`}
                            name="text"
                            value={item.text}
                            type="text"
                            label="Text"
                            id="textLabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                </>

            case 'submit':

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confButtonName-${item.id}`}
                            name="buttonName"
                            value={item.name}
                            type="text"
                            label="Button Name"
                            id="buttonName"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confButtonText-${item.id}`}
                            name="buttonText"
                            value={item.buttonText}
                            type="text"
                            label="Button Text"
                            id="buttonText"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`buttonAlignment-${item.id}`}>Button Alignment</InputLabel>
                        <NativeSelect
                            key={`confButtonAlignment-${item.id}`}
                            name="buttonAlignment"
                            id="buttonAlignment"
                            value={item.buttonAlignment}
                            label="Button Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="auto">Auto</option>
                            <option value="left">Left</option>
                            <option value="center">Center</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                </>

            default:

                return <>Item {item.id}</>

        }

    }

    const onSubmitTag = (e) => {

        e.preventDefault();

        // check if name is different
        const parentTagName = userDataState.tags.filter(item => item.id === addTagData.id)[0].name;

        if(addTagData.name === parentTagName){

            enqueueSnackbar('The name must be different from the parent name.', {
                variant: 'error'
            });

            return false;

        } else {

            setAddingTag(true);

            dispatch(addTag(addTagData))
                .then((response) => {

                    if(response.payload){

                        if(response.payload.error === 0){

                            dispatch(userDataUpdated()).then((response) => {

                                setUserDataState({...response.payload.user_data});

                                setAddNewTag(false);

                                enqueueSnackbar('New tag was successfully added!', {
                                    variant: 'success'
                                });

                                setAddTagData({
                                    'id': null,
                                    'name': ''
                                });

                            });

                            setAddingTag(false);

                        } else {

                            enqueueSnackbar(`Error! Server says: ${response.payload.msg}`, {
                                variant: 'error'
                            });

                            setAddingTag(false);

                            return false;

                        }

                    } else {

                        enqueueSnackbar(`Error! We have some problems with Server!`, {
                            variant: 'error'
                        });

                        setAddingTag(false);

                        return false;

                    }

                });

        }

    }

    const onSubmit = (data) => {

        const submitType = window.event.submitter.value;

        setScreenShooting(true);

        const sendioForm = sendioFormRef.current;

        setTimeout(function () {

            setValue('json', formData.json);

            data.json = formData.json;

            if(data.list_type == 'both'){

                if(data.list_id === null){
                    enqueueSnackbar('You should select Email List!', {
                        variant: 'error'
                    });
                    return false;
                }

                if(data.phone_number_list_id === null){
                    enqueueSnackbar('You should select Phone List!', {
                        variant: 'error'
                    });
                    return false;
                }

            } else if(data.list_type == 'emails'){

                if(data.list_id === null){
                    enqueueSnackbar('You should select Email List!', {
                        variant: 'error'
                    });
                    return false;
                }

            } else if(data.list_type == 'phone_numbers'){

                if(data.phone_number_list_id === null){
                    enqueueSnackbar('You should select Phone List!', {
                        variant: 'error'
                    });
                    return false;
                }

            }

            if(data.list_type == 'both' || data.list_type == 'emails'){

                let containsEmail = 0;

                data.json.formContent.forEach((element) => {

                    if(element.type === 'email'){
                        containsEmail = containsEmail + 1;
                    }

                });

                if(containsEmail != 1){
                    enqueueSnackbar('Form should contains one email field!', {
                        variant: 'error'
                    });
                    return false;
                }



            }

            if(data.list_type == 'both' || data.list_type == 'phone_numbers'){

                let containsNumber = 0;

                data.json.formContent.forEach((element) => {

                    if(element.type === 'number'){
                        containsNumber = containsNumber + 1;
                    }

                });

                if(containsNumber != 1){
                    enqueueSnackbar('Form should contains one number field!', {
                        variant: 'error'
                    });
                    return false;
                }

            }

            let containsSubmit = 0;

            data.json.formContent.forEach((element) => {

                if(element.type === 'submit'){
                    containsSubmit = containsSubmit + 1;
                }

            });

            if(containsSubmit != 1){

                enqueueSnackbar('Form should contains one submit button!', {
                    variant: 'error'
                });

                return false;

            }

            // Check for unique and not empty all fields!!!
            let validationError = '';

            data.json.formContent.forEach((formItem) => {

                if(formItem.type !== 'heading' && formItem.type !== 'paragraph'){

                    // check for not empty
                    if(!formItem.name || formItem.name === ''){
                        validationError += `${formItem.type} shouldn\`t be emty!\n`;
                    }

                    // check for unique
                    data.json.formContent.forEach((formItem2) => {

                        if(formItem.id !== formItem2.id){

                            if(formItem.name === formItem2.name){
                                validationError += `${formItem2.type} should be unique!\n`;
                            }

                        }

                    });

                }

            });

            if(validationError !== ''){

                validationError = `Error: ${validationError}`;

                enqueueSnackbar(validationError, {
                    variant: 'error'
                });

                return false;

            }

            takeScreenshot(sendioForm).then((screen) => {

                const formData = new FormData();

                if(data.list_type === 'emails'){
                    data.phone_number_list_id = null;
                } else if(data.list_type === 'phone_numbers'){
                    data.list_id = null;
                }

                formData.append('name', data.name);
                formData.append('preview', screen);
                formData.append('owner_id', data.owner_id);
                formData.append('list_id', data.list_id);
                if(API_BASE === 'localhost'){
                    formData.append('phone_number_list_id', data.phone_number_list_id);
                } else {
                    formData.append('number_list_id', data.phone_number_list_id);
                }
                formData.append('callback_url', data.callback_url);
                formData.append('already_subscribed_url', data.already_subscribed_url);
                formData.append('use_captcha', data.use_captcha ? 1 : 0);
                formData.append('json', JSON.stringify(data.json));
                if(data.tags.length > 0){
                    formData.append('tags', JSON.stringify(data.tags));
                } else {
                    formData.append('tags', null);
                }
                if(tagsUpdated){
                    formData.append('tags_updated', tagsUpdated);
                }
                formData.append('views', data.views);
                formData.append('emails_lists_subscribes', data.emails_lists_subscribes);
                formData.append('phone_numbers_lists_subscribes', data.phone_numbers_lists_subscribes);

                if(id){

                    formData.append('id', parseInt(id));

                    if(API_BASE === 'localhost'){
                        !keepLogo && formData.append('logo', data.logo);
                    } else {
                        !keepLogo ? formData.append('logo', data.logo) : formData.append('logo', 'keep');
                    }

                    dispatch(updateForm(formData))
                        .then((response) => {

                            if(response.payload){

                                if(response.payload.error === 0){

                                    enqueueSnackbar('Your form was successfully updated!', {
                                        variant: 'success'
                                    });

                                    if(submitType === 'leave'){
                                        //history.push('/');
                                        history.replace('/');
                                    }
                                    /* else {
                                        history.go(0);
                                    }*/

                                } else {

                                    enqueueSnackbar(response.payload.msg, {
                                        variant: 'error'
                                    });

                                }

                            } else {

                                enqueueSnackbar('An error occurred when you tried to update the form!', {
                                    variant: 'error'
                                });

                            }

                            setScreenShooting(false);

                        });

                } else {

                    if(API_BASE === 'localhost'){
                        !keepLogo && formData.append('logo', data.logo);
                    } else {
                        !keepLogo ? formData.append('logo', data.logo) : formData.append('logo', null);
                    }

                    dispatch(addForm(formData)).then((response) => {

                        if(response.payload){

                            if(response.payload.error === 0){

                                enqueueSnackbar('Your form was successfully saved!', {
                                    variant: 'success'
                                });

                                if(submitType === 'leave'){
                                    history.replace('/');
                                } else {
                                    if(response.payload.form && response.payload.form.id){
                                        history.replace(`/form/${response.payload.form.id}`);
                                    } else {
                                        // console.log('Undefined formID response.');
                                        history.replace('/');
                                        //history.push('/');
                                    }
                                }

                            } else {

                                enqueueSnackbar(response.payload.msg, {
                                    variant: 'error'
                                });

                            }

                        } else {

                            enqueueSnackbar('An error occurred when you tried to add the form!', {
                                variant: 'error'
                            });

                        }

                    });

                }

            });

        });

    };

    useEffect(() => {

        document.addEventListener('click', handleSelectElement, true);

        return () => {
            document.removeEventListener('click', handleSelectElement, true);
        };

    }, []);

    useEffect(() => {

        WebFont.load({
            google: {
                families: FontFamilies.google
            }
        });

    }, []);

    const useColorScheme = (color) => {

        // Use Color Scheme

        let schemesProps = ColorSchemes[color];

        if(!ColorSchemes[color] || ColorSchemes[color].length === 0){

            schemesProps = ColorSchemes['white'];

        }

        for (const [key, value] of Object.entries(schemesProps)) {

            document.body.style.setProperty(`--Sendiio${key}`, value);

        }

    }

    useEffect(() => {

        // for update an existing record
        if(id){

            dispatch(getForm(id)).then((response) => {

                setLoading(false);

                if(response.payload){

                    if(response.payload.error === 0){

                        const data = response.payload.data;

                        if(parseInt(data.owner_id) !== parseInt(user.owner_id)){
                            history.replace('/');
                        }

                        if(API_BASE === 'localhost'){

                            data.json = JSON.parse(JSON.parse(data.json));

                            if(data.tags && data.tags !== ''){
                                data.tags = JSON.parse(JSON.parse(data.tags));
                                if(!data.tags){
                                    data.tags = [];
                                }
                                setFormTags(data.tags);
                            } else {
                                data.tags = [];
                            }

                        } else {

                            data.json = JSON.parse(data.json);

                            if(data.form_tags && data.form_tags !== '') {

                                data.tags = [];

                                if(data.form_tags.length > 0){

                                    data.form_tags.forEach((formTag, index) => {
                                        data.tags[index] = {};
                                        data.tags[index].tag_id = JSON.parse(formTag.tags_ids);
                                        data.tags[index].input = formTag.name;
                                        data.tags[index].values = JSON.parse(formTag.value);
                                        data.tags[index].valuesInput = '';
                                        data.tags[index].value_condition = formTag.value_condition;
                                    });

                                }

                                setFormTags(data.tags);

                                delete data.form_tags;

                            }

                        }

                        checkFormElements(data);

                        useColorScheme(data.json.formColorScheme);

                        data.list_type = 'both';

                        if(!data.list_id || data.list_id === ''){
                            data.list_type = 'phone_numbers';
                        } else if(!data.phone_number_list_id || data.phone_number_list_id === ''){
                            data.list_type = 'emails';
                        }

                        setValue('name', data.name);
                        setValue('preview', data.preview);
                        if(data.logo && data.logo !== ''){
                            data.logo = API_BASE === 'localhost' ? data.logo : `https://sendiio.com/forms/${data.id}/logo`;
                        }
                        setValue('logo', data.logo);
                        setValue('owner_id', data.owner_id);
                        setValue('list_type', data.list_type);
                        setValue('list_id', data.list_id);
                        setValue('phone_number_list_id', data.phone_number_list_id);
                        if(API_BASE === 'localhost') {
                            setValue('callback_url', data.callback_url);
                            setValue('already_subscribed_url', data.already_subscribed_url);
                            setValue('use_captcha', parseInt(data.use_captcha));
                        } else {
                            setValue('callback_url', data.callback);
                            setValue('already_subscribed_url', data.already_subscribed_callback);
                            setValue('use_captcha', data.use_captcha);
                        }
                        setValue('json', data.json);

                        setFormData(data);

                        // if unset name, let`s generate it!
                        data.json.formContent.forEach((item) => {

                            if(item.type !== 'heading' && item.type !== 'paragraph'){

                                if(!item.name || item.name === ''){

                                    item.name = `${item.type}-${generateUniqueNumber(6)}`;

                                }

                            }

                        });

                        if(data.tags && data.tags.length > 0){
                            data.tags.forEach((tag, index) => {
                                if(data.tags[index].tag_id && data.tags[index].tag_id.length > 0){
                                    data.tags[index].tags = [];
                                    data.tags[index].tag_id.forEach((tagId, i) => {
                                        const tagName = userDataState.tags.filter(item => item.id === tagId)[0].name;
                                        data.tags[index].tags.push(tagName);
                                    });
                                }
                            });
                        }

                        setFormTags(data.tags);

                        setListType(data.list_type);

                        if(userDataState['email_lists'].length > 0){
                            !getValues('list_id') && setValue('list_id', userDataState['email_lists'][0].id);
                        }

                        if(userDataState['phone_lists'].length > 0){
                            !getValues('phone_number_list_id') && setValue('phone_number_list_id', userDataState['phone_lists'][0].id);
                        }

                        if(userDataState['tags'].length > 0){

                            setUseTags(true);

                        }

                    } else {

                        enqueueSnackbar(response.payload.msg, {
                            variant: 'error'
                        });

                        history.push('/');

                    }

                } else {

                    enqueueSnackbar('An error occurred when we tried to get your form!', {
                        variant: 'error'
                    });

                }

            });

        // for a new record
        } else {

            setLoading(false);

            useColorScheme(getValues('json').formColorScheme);

            setListType('emails');

            if(userDataState['email_lists'] && userDataState['email_lists'].length > 0){
                !getValues('list_id') && setValue('list_id', userDataState['email_lists'][0].id);
            }

            if(userDataState['phone_lists'] && userDataState['phone_lists'].length > 0){
                !getValues('phone_number_list_id') && setValue('phone_number_list_id', userDataState['phone_lists'][0].id);
            }

            if(userDataState['tags'].length > 0){

                setUseTags(true);

            }

        }

    }, []);

    // name, firstname & lastname can be used only once!
    const checkDisabled = (item) => {

        if(item.type === 'name'){

            let containsName = false

            formData.json.formContent.forEach((formEl) => {

                if(formEl.type === 'name'){
                    containsName = true;
                }

            })

            return containsName;

        }

        if(item.type === 'firstname'){

            let containsName = false

            formData.json.formContent.forEach((formEl) => {

                if(formEl.type === 'firstname'){
                    containsName = true;
                }

            })

            return containsName;

        }

        if(item.type === 'lastname'){

            let containsName = false

            formData.json.formContent.forEach((formEl) => {

                if(formEl.type === 'lastname'){
                    containsName = true;
                }

            })

            return containsName;

        }

    }

    if(loading){
        return <p>Loading...</p>
    }

    return <>

        <DragDropContext onDragEnd={onDragEnd}>

            <form onSubmit={handleSubmit(onSubmit, onError)} style={{ display: 'flex', height: '100%' }}>

                <div className={clsx(classes.leftBar)} style={{ top: mobile ? '56px' : '64px' }}>

                    <Drawer variant="permanent" open={open}>

                        <Toolbar
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                px: [open ? 1 : 1],
                            }}
                        >
                            <Typography variant="h6" noWrap component="div" display="flex" width="100%" justifyContent="flex-start" alignItems="center">
                                <IconButton onClick={() => {}}>
                                    <DashboardCustomizeIcon />
                                </IconButton>
                                <span className="ps-24">Form Elements</span>
                            </Typography>

                        </Toolbar>

                        <Divider />

                        <List component="nav">

                            <Droppable droppableId="formElements" isDropDisabled={true}>
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        //isDraggingOver={snapshot.isDraggingOver}
                                    >

                                        {formElements.map((item, index) => (
                                            <Draggable
                                                key={item.id}
                                                draggableId={item.id}
                                                isDragDisabled={item.disabled || checkDisabled(item)}
                                                index={index}>
                                                {(provided, snapshot) => (
                                                    <React.Fragment>
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            onClick={() => {
                                                                if(!item.disabled && !checkDisabled(item)){
                                                                    addToFormManually(item, index);
                                                                }
                                                            }}
                                                            //isDragging={snapshot.isDragging}
                                                            className={clsx(checkDisabled(item) && classes.disabledDND, item.disabled && classes.hideDND)}
                                                            style={
                                                                provided.draggableProps.style
                                                            }>
                                                            <ListItemButton>
                                                                <ListItemIcon>
                                                                    <Icon color="action">{item.icon}</Icon>
                                                                </ListItemIcon>
                                                                <ListItemText primary={item.content} />
                                                            </ListItemButton>
                                                        </div>
                                                        {snapshot.isDragging && (

                                                            <ListItemButton>
                                                                <ListItemIcon>
                                                                    <Icon color="action">{item.icon}</Icon>
                                                                </ListItemIcon>
                                                                {/*<ListItemText primary={`draggling` + item.content} />*/}
                                                                <ListItemText primary={item.content} />
                                                            </ListItemButton>

                                                        )}
                                                    </React.Fragment>
                                                )}
                                            </Draggable>
                                        ))}

                                    </div>
                                )}
                            </Droppable>

                        </List>

                    </Drawer>

                    {!mobile &&
                    <IconButton className={clsx(classes.leftBarToggler, 'rounded-0')} color="primary" onClick={toggleDrawer} disableRipple>
                        {open ? <ChevronLeftIcon/> : <ChevronRightIcon />}
                    </IconButton>}

                </div>

                <Container className="form-container" maxWidth="lg" sx={{ mt: 4, mb: 4 }}>

                    <Typography typography={mobile ? 'h4' : 'h2'} textAlign="center">Form manager</Typography>

                    <Box className={clsx(classes.formWrapper, 'sendiio-form-wrapper', `sendiio-form-family-${formData.json.formFontFamily}`)}>

                        <div id="sendioFormRef" ref={sendioFormRef} className='sendiio-form-default' style={{paddingLeft: mobile ? 60 : 'inherit', width: mobile ? '100%' : (formData.json.formWidthAuto ? '460px' : `${formData.json.formWidth}px`)}}>

                            <ImageUploader
                                logo={formData.logo}
                                logoParameters={formData.json.formLogo}
                                screenShooting={screenShooting}
                                openConfigurator={handleOpenConfigurator}
                                updateLogoData={handleUpdateLogoData} />

                            <div className={clsx('sendiio-form', `sendiio-form-template-${formData.json.formTemplate}`, `sendiio-form-color-scheme-${formData.json.formColorScheme}`, `sendiio-form-type-${formData.list_type}`)} style={{width: mobile ? '100%' : (formData.json.formWidthAuto ? '460px' : `${formData.json.formWidth}px`)}}>

                                <Droppable droppableId="userForm">
                                    {(provided, snapshot) => (
                                        <ul {...provided.droppableProps}
                                            ref={provided.innerRef}
                                            className={clsx(classes.formList, 'form-manager-list')}
                                            style={getListStyle(snapshot.isDraggingOver)}>

                                            {formData.json.formContent.length > 0 && formData.json.formContent.map((item, index) => (

                                                <Draggable key={item.id} draggableId={item.id} index={index}>
                                                    {(provided, snapshot) => (

                                                        <li
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            className={clsx('sendiio-element', item.selected ? 'selected' : '', `sendiio-element-type-${item.type}`)}
                                                            onDoubleClick={(e) => handleOpenConfigurator(e, item.id)}
                                                            style={getItemStyle(
                                                                snapshot.isDragging,
                                                                provided.draggableProps.style
                                                            )}>

                                                            {(item.type === 'submit' && parseInt(getValues('use_captcha')) > 0) &&

                                                                <img src={recaptcha} className={classes.recaptcha} alt="Recaptcha" />

                                                            }

                                                            {formElement(item)}

                                                            <div className="selectedControls">
                                                                <IconButton className="dragIndicator" disabled>
                                                                    <DragIndicatorIcon />
                                                                </IconButton>
                                                                <IconButton className="settingsIcon" onClick={e => handleOpenConfigurator(e, item.id)}>
                                                                    <SettingsIcon />
                                                                </IconButton>
                                                                {!deletableElements[item.type] &&
                                                                <IconButton className="removeIcon" onClick={(e) => handleRemove(e, item.id)}>
                                                                    <DeleteIcon />
                                                                </IconButton>}
                                                            </div>

                                                        </li>

                                                    )}
                                                </Draggable>

                                            ))}

                                            {formData.json.formContent.length === 0 &&

                                                <Draggable key="draggable-0" draggableId="draggable-0" index={0} isDragDisabled={true}>
                                                    {(provided, snapshot) =>
                                                        <li className="emptyPlaceholderLine disable-drag"
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            onClick={handleClickEmptyElement}
                                                            style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}>
                                                            <Empty/>
                                                        </li>
                                                    }
                                                </Draggable>

                                            }

                                            {provided.placeholder}

                                        </ul>
                                    )}
                                </Droppable>

                            </div>

                        </div>

                    </Box>

                    <Stack
                        className="mt-50 pb-48 text-center"
                        spacing={2}
                        justifyContent="center"
                        display={'flex'}
                        style={{paddingLeft: mobile ? 60 : 'inherit'}}
                        direction={mobile ? 'column' : 'row'}>
                        <Button variant="outlined"
                                size="large"
                                onClick={e => {

                                    e.preventDefault();

                                    history.push('/');

                                }}
                                startIcon={<ArrowBackIcon />}>
                            Home
                        </Button>
                        <Button id="saveForm"
                                size="large"
                                variant="contained"
                                type="submit"
                                value="stay"
                                endIcon={<SaveAsIcon />}>
                            Save
                        </Button>
                        <Button id="saveLeaveForm"
                                size="large"
                                variant="contained"
                                type="submit"
                                value="leave"
                                endIcon={<SaveIcon />}>
                            Save & Leave
                        </Button>
                    </Stack>

                </Container>

                <div ref={configuratorRef} className={clsx('configuratorWrapper', classes.rightBar)} style={{ top: mobile ? '56px' : '64px' }}>

                    <RightDrawer
                            variant="permanent"
                            anchor="right"
                            open={openConfigurator}>

                        <Toolbar
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                            }}
                            className="px-16"
                        >

                            <Typography variant="h6" noWrap component="div" display="flex" width="100%" justifyContent="space-between" alignItems="center">
                                <span>{configuratorData && configuratorData.itemID ? "Field Settings" : "Form Configurator"}</span>
                            </Typography>

                            {configuratorData && configuratorData.itemID &&
                                <Tooltip title="Close Field Settings" placement="left">
                                    <IconButton
                                        color="primary"
                                        onClick={ (e) => handleOpenConfigurator(e, null)}
                                        disableRipple>
                                        <CloseIcon />
                                    </IconButton>
                                </Tooltip>
                            }

                        </Toolbar>

                        <Divider />

                        <div className="px-16">

                            <div className="configuratorContent">

                                <div className={clsx(activeConfiguratorItem && 'hidden', 'configuratorContentForm', 'flex', 'flex-col', 'pt-12')}>

                                    <Controller
                                        name='name'
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                className="mt-16 mb-6"
                                                label="Form Name"
                                                variant="outlined"
                                                fullWidth
                                                error={errors.name && true}
                                                helperText={errors.name && errors.name.message}
                                                //required
                                            />
                                        )}
                                    />

                                    <FormControl className="hidden">
                                        <TextField
                                            required
                                            key="formOwnerID"
                                            name="formOwnerID"
                                            value={user.owner_id}
                                            type="hidden"
                                            label="Form Owner ID"
                                            id="formOwnerID"
                                        />
                                    </FormControl>

                                    {userDataState && <>

                                        <Controller
                                            name='list_type'
                                            control={control}
                                            render={({ field }) => (
                                                <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                                                    <InputLabel id={`formListTypeLabel`}>List Type</InputLabel>
                                                    <NativeSelect {...field} label="List Type"
                                                                  onChange={(e) => {
                                                                      const val = e.target.value;
                                                                      field.onChange(val);
                                                                      setListType(val);
                                                                      handleInputChange(e, null);
                                                                      //changeForm(e.target.value);
                                                                  }}
                                                                  //required
                                                    >
                                                        <option value="emails">Emails</option>
                                                        <option value="phone_numbers">Phone numbers</option>
                                                        <option value="both">Emails and phone numbers</option>
                                                    </NativeSelect>
                                                    {errors.list_type && <FormHelperText>{errors.list_type.message}</FormHelperText>}
                                                </FormControl>
                                            )}
                                        />

                                        <Controller
                                            name='list_id'
                                            control={control}
                                            render={({ field }) => (
                                                <FormControl
                                                    variant="outlined"
                                                    className={clsx('mt-16', 'mb-6', listType === 'phone_numbers' && 'hidden')}
                                                    error={errors.list_id && true}
                                                    fullWidth>
                                                    <InputLabel id={`formListIdLabel`}>Email List *</InputLabel>
                                                    <NativeSelect
                                                        {...field}
                                                        value={listType !== 'phone_numbers' ? field.value : ''}
                                                        label="Email List"
                                                        //required={listType !== 'phone_numbers' && true}
                                                    >
                                                        {userDataState['email_lists'] && userDataState['email_lists'].map((item) => <option key={`email-list-key-${item.id}`} value={item.id}>{item.name}</option>)}
                                                    </NativeSelect>
                                                    {errors.list_id && <FormHelperText>{errors.list_id.message}</FormHelperText>}
                                                </FormControl>
                                            )}
                                        />

                                        <Controller
                                            name='phone_number_list_id'
                                            control={control}
                                            render={({ field }) => (
                                                <FormControl variant="outlined" className={clsx('mt-16', 'mb-6', listType === 'emails' && 'hidden')} error={errors.phone_number_list_id && true} fullWidth>
                                                    <InputLabel id={`formPhoneNumberListIdLabel`}>Phone List *</InputLabel>
                                                    <NativeSelect
                                                        {...field}
                                                        value={listType !== 'emails' ? field.value : ''}
                                                        label="Phone ID"
                                                        //required={listType !== 'emails' && true}
                                                    >
                                                        {userDataState['phone_lists'] && userDataState['phone_lists'].map((item) => <option key={`phone-list-key-${item.id}`} value={item.id}>{item.name}</option>)}
                                                    </NativeSelect>
                                                    {errors.phone_number_list_id && <FormHelperText>{errors.phone_number_list_id.message}</FormHelperText>}
                                                </FormControl>
                                            )}
                                        />

                                    </>}

                                    <Controller
                                        name='callback_url'
                                        control={control}
                                        render={({ field }) => (
                                            <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                                                <TextField
                                                    {...field}
                                                    label="Successfully Subscribed URL"
                                                    variant="outlined"
                                                    fullWidth
                                                    error={errors.callback_url && true}
                                                    helperText={errors.callback_url && errors.callback_url.message}
                                                    //required
                                                />
                                            </FormControl>
                                        )}
                                    />

                                    <Controller
                                        name='already_subscribed_url'
                                        control={control}
                                        render={({ field }) => (
                                            <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                                                <TextField
                                                    {...field}
                                                    label="Already Subscribed URL"
                                                    variant="outlined"
                                                    fullWidth
                                                    error={errors.already_subscribed_url && true}
                                                    helperText={errors.already_subscribed_url && errors.already_subscribed_url.message}
                                                    //required
                                                />
                                            </FormControl>
                                        )}
                                    />

                                    <Controller
                                        name='use_captcha'
                                        control={control}
                                        render={({ field }) => (
                                            <FormControlLabel
                                                label="Use Captcha"
                                                control={
                                                    <Checkbox
                                                        {...field}
                                                        onChange={(e) => {
                                                            field.onChange(e.target.checked ? 1 : 0);
                                                        }}
                                                        checked={parseInt(field.value) > 0 && true}
                                                        size="small"
                                                    />
                                                }
                                            />
                                        )}
                                    />

                                    {userDataState && useTags &&
                                        <>

                                            <Controller
                                                name='enable_tags'
                                                control={control}
                                                render={({ field }) => (
                                                    <FormControlLabel
                                                        label="Enable Tags Automation"
                                                        control={
                                                            <Checkbox
                                                                {...field}
                                                                onChange={(e) => {
                                                                    handleOpenTagsDialog();
                                                                }}
                                                                checked={(formData.tags && formData.tags.length > 0) ? true : false}
                                                                size="small"
                                                            />
                                                        }
                                                    />
                                                )}
                                            />

                                            <FormControl className="hidden">
                                                <TextField
                                                    required
                                                    key="tags"
                                                    name="tags"
                                                    value={formData.tags ? formData.tags : ''}
                                                    type="hidden"
                                                    id="tags"
                                                />
                                            </FormControl>

                                        </>

                                    }

                                    <ListSubheader component="div" id="nested-list-subheader" className="mt-24">
                                        Form Styles
                                    </ListSubheader>

                                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                                        <TextField
                                            key="formWidth"
                                            name="formWidth"
                                            value={formData.json.formWidth}
                                            type="number"
                                            InputProps={{ inputProps: { min: 200, max: 1200 } }}
                                            disabled={formData.json.formWidthAuto && true}
                                            label="Form Width"
                                            id="formWidth"
                                            variant="outlined"
                                            fullWidth
                                            onInput={e => handleInputChange(e, null)}
                                        />
                                    </FormControl>

                                    <FormControlLabel
                                        label="Auto width"
                                        control={
                                            <Checkbox
                                                name="formWidthAuto"
                                                size="small"
                                                checked={formData.json.formWidthAuto}
                                                onChange={e => handleInputChange(e, null)}
                                            />
                                        }
                                    />

                                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                                        <InputLabel id={`formTemplateLabel`}>Template</InputLabel>
                                        <NativeSelect
                                            key={`confFormTemplateLabel`}
                                            name="formTemplate"
                                            id="formTemplate"
                                            defaultValue={formData.json.formTemplate}
                                            label="Template"
                                            onChange={e => handleInputChange(e, null)}>
                                            {Templates.map((template, index) => <option key={`template-${index}`} value={template.name}>{template.title}</option>)}
                                        </NativeSelect>
                                    </FormControl>

                                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                                        <InputLabel id={`formColorSchemeLabel`}>Color Scheme</InputLabel>
                                        <NativeSelect
                                            key={`confFormColorSchemeLabel`}
                                            name="formColorScheme"
                                            id="formColorScheme"
                                            defaultValue={formData.json.formColorScheme}
                                            label="Color Scheme"
                                            onChange={e => handleInputChange(e, null)}>
                                            <option value="default">Default</option>
                                            <option value="dark">Dark</option>
                                            <option value="blue">Blue</option>
                                            <option value="azure">Azure</option>
                                            <option value="orange">Orange</option>
                                            <option value="brown">Brown</option>
                                            <option value="lime">Lime</option>
                                            <option value="green">Green</option>
                                            <option value="violet">Violet</option>
                                            <option value="pink">Pink</option>
                                            <option value="red">Red</option>
                                            <option value="white">White</option>
                                        </NativeSelect>
                                    </FormControl>

                                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                                        <InputLabel id={`labelsAlignment`}>Label`s Alignment</InputLabel>
                                        <NativeSelect
                                            key={`confLabelsAlignment`}
                                            name="labelsAlignment"
                                            id="labelsAlignment"
                                            defaultValue="top"
                                            label="Label Alignment"
                                            onChange={e => handleLabelsAlignment(e)}>
                                            <option value="top">Top</option>
                                            <option value="left">Left</option>
                                            <option value="right">Right</option>
                                        </NativeSelect>
                                    </FormControl>

                                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                                        <InputLabel id={`formFontFamilyLabel`}>Font Family</InputLabel>
                                        <NativeSelect
                                            key={`confFormFontFamilyLabel`}
                                            name="formFontFamily"
                                            id="formFontFamily"
                                            defaultValue={formData.json.formFontFamily}
                                            label="Font Family"
                                            onChange={e => handleInputChange(e, null)}>
                                            <option value="roboto">Roboto</option>
                                            <option value="open-sans">Open Sans</option>
                                            <option value="lato">Lato</option>
                                            <option value="inter">Inter</option>
                                            <option value="raleway">Raleway</option>
                                        </NativeSelect>
                                    </FormControl>

                                    {(formData.logo && formData.logo !== '') &&
                                        <div className="mt-36 flex flex-col">

                                            <InputLabel shrink htmlFor="logo-legend">
                                                Edit Your Logo
                                            </InputLabel>

                                            <p className={classes.logoFileName}>{formData.json.formLogo.filename}</p>

                                            <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                                                <InputLabel id="headingLogoAlign">Logo Alignment</InputLabel>
                                                <NativeSelect
                                                    key={`confLogoAlignment`}
                                                    name="formLogoAlignment"
                                                    id="logoAlignment"
                                                    value={formData.json.formLogo.alignment}
                                                    label="Logo Alignment"
                                                    onChange={e => handleInputChange(e)}>
                                                    <option value="left">Left</option>
                                                    <option value="center">Center</option>
                                                    <option value="right">Right</option>
                                                </NativeSelect>
                                            </FormControl>

                                            <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                                                <TextField
                                                    key="formLogoWidth"
                                                    name="formLogoWidth"
                                                    value={formData.json.formLogo.width}
                                                    type="number"
                                                    InputProps={{ inputProps: { min: 64, max: 1200 } }}
                                                    disabled={true}
                                                    label="Logo Width"
                                                    id="formLogoWidth"
                                                    variant="outlined"
                                                    fullWidth
                                                    onInput={e => handleInputChange(e, null)}
                                                />
                                            </FormControl>

                                            <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                                                <TextField
                                                    key="formLogoHeight"
                                                    name="formLogoHeight"
                                                    value={formData.json.formLogo.height}
                                                    type="number"
                                                    InputProps={{ inputProps: { min: 64, max: 1200 } }}
                                                    disabled={true}
                                                    label="Logo Height"
                                                    id="formLogoHeight"
                                                    variant="outlined"
                                                    fullWidth
                                                    onInput={e => handleInputChange(e, null)}
                                                />
                                            </FormControl>

                                        </div>
                                    }

                                </div>

                                <div className="configuratorContentItems">
                                {formData.json.formContent.length > 0 && formData.json.formContent.map((item, index) => (

                                    <div key={`key-conf-${item.id}`} className={clsx(activeConfiguratorItem !== item.id && 'hidden', 'configuratorContentItem', 'flex', 'flex-col', 'pt-12')}>
                                        {elementConfigurator(item)}
                                    </div>

                                ))}
                                </div>

                            </div>

                        </div>

                    </RightDrawer>

                    <IconButton className={clsx(classes.rightBarToggler, 'rounded-0')}
                                color="primary"
                                onClick={(e) => {
                                    openConfigurator ? setOpenConfigurator(false) : handleOpenConfigurator(e, null)
                                }}
                                disableRipple>
                        {openConfigurator ? <ChevronRightIcon/> :
                            <Tooltip title="Form Configurator" placement="left">
                                <StyleIcon />
                            </Tooltip>
                        }
                    </IconButton>

                </div>

            </form>

        </DragDropContext>

        {userDataState &&

            <Dialog open={tagsDialogOpened} sx={{top: 65}} fullScreen>
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleCloseTagsDialog}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            Tags Automations
                        </Typography>
                        <Button autoFocus color="inherit" onClick={e => {

                            e.preventDefault();

                            const tagsErrors = [];

                            formTags.forEach((formTag, index) => {

                                if(formTag.input === "" || formTag.tags.length === 0 || formTag.values.length === 0){
                                    tagsErrors.push(index);
                                }

                            });

                            const formTagsToSave = [];

                            tagsListRefs.current.forEach((tagRef, index) => {

                                if(tagRef){
                                    if(tagsErrors.includes(index)){
                                        tagRef.classList.add('error');
                                    } else {
                                        tagRef.classList.add('success');
                                        formTagsToSave.push(formTags[index]);
                                    }
                                }

                            });

                            if(tagsErrors.length > 0){
                                enqueueSnackbar('Parts of your tags have been saved successfully! Please check the others, all fields must be filled!', {
                                    variant: 'warning'
                                });
                            } else {
                                enqueueSnackbar('All your tags were successfully saved!', {
                                    variant: 'success'
                                });
                            }

                            setTimeout(function () {

                                tagsListRefs.current.forEach((tagRef) => {
                                    if(tagRef){
                                        tagRef.classList.remove('error', 'success');
                                    }
                                });

                            }, 1000);

                            let currentForm = { ...formData };

                            currentForm.tags = formTagsToSave;

                            setValue('tags', formTagsToSave);

                            if(id){
                                setTagsUpdated(true);
                            }

                            setFormData(currentForm);

                        }}>
                            Save
                        </Button>
                    </Toolbar>
                </AppBar>
                <List>
                    <div key={`list-div-key-clone-tag`}>

                        <Alert severity="warning" className="my-10">
                            <span>Please note that in order to save tag automation settings you should also save changes to the form itself.</span>
                        </Alert>

                        {addNewTag ?
                        <>
                            <form style={{padding: '0px 15px 0 25px'}} onSubmit={e => onSubmitTag(e)}>
                                <div style={{display: 'flex', justifyContent: 'center'}}>
                                    <FormControl sx={{ m: 1, minWidth: 300, height: '100%' }}>
                                        <TextField
                                            id="clone-tag-id"
                                            label="Copy Settings From"
                                            size="small"
                                            defaultValue={addTagData.id}
                                            onChange={e => {

                                                const {target: { value }} = e;

                                                const currentTagData = {...addTagData};

                                                currentTagData.id = value;

                                                setAddTagData(currentTagData);

                                            }}
                                            select
                                            required>
                                            {userDataState['tags'].map((tag) => (
                                                <MenuItem
                                                    id={`clone-tag-${tag.id}`}
                                                    key={`clone-tag-chip-key-${tag.name}`}
                                                    value={tag.id}
                                                >
                                                    {tag.name}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </FormControl>
                                    <FormControl sx={{ m: 1, minWidth: 300, height: '100%' }}>
                                        <TextField
                                            id="clone-tag-name"
                                            label="New Tag Name"
                                            size="small"
                                            defaultValue={addTagData.name}
                                            onBlur={e => {

                                                const {target: { value }} = e;

                                                const currentTagData = {...addTagData};

                                                currentTagData.name = value;

                                                setAddTagData(currentTagData);

                                            }}
                                            required
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1, minWidth: 140 }}>
                                        <Button type="submit"
                                                variant="contained"
                                                color="primary"
                                                disabled={addingTag}
                                                sx={{height: '100%'}}>
                                            {addingTag && <CircularProgress size={12} color="inherit" sx={{marginRight: 1}} />} Create
                                        </Button>
                                    </FormControl>
                                    <FormControl sx={{ m: 1, minWidth: 140 }}>
                                        <Button variant="outlined"
                                                color="primary"
                                                sx={{height: '100%'}}
                                                disabled={addingTag}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setAddNewTag(false);
                                                    setAddTagData({
                                                        'id': null,
                                                        'name': ''
                                                    });
                                                }}>
                                            Cancel
                                        </Button>
                                    </FormControl>
                                </div>
                                <Alert severity="info">
                                    <span>If you need a clean tag for your leads you can quickly create it above by using an existing tag as a template.</span>
                                </Alert>
                            </form>
                        </> :
                        <ListItem
                            sx={{justifyContent: 'center'}}
                            key={`list-key-clone-tag`}
                            onClick={(e) => {

                                e.preventDefault();

                                setAddNewTag(true);

                            }}
                            button
                        >
                            <AddIcon sx={{marginRight: 1}} /> <span>New Tag</span>
                        </ListItem>}
                    </div>
                    <hr/>
                    {formTags.map((formTag, index) =>
                        <div key={`list-div-key-${index}`}>
                            <ListItem
                                className={classes.listTag}
                                ref={(e) => (tagsListRefs.current[index] = e)}
                                key={`list-key-${index}`}
                                secondaryAction={
                                    <IconButton edge="end"
                                                aria-label="delete"
                                                onClick={(e) => {

                                                    e.preventDefault();

                                                    let currentFormTags = [...formTags];

                                                    currentFormTags.splice(index, 1);

                                                    setFormTags(currentFormTags);

                                                }}>
                                        <DeleteIcon />
                                    </IconButton>
                                }
                            >
                                <FormControl key={`tags-form-control-key-${index}`} sx={{ m: 1, width: 300 }}>
                                    <InputLabel key={`tags-label-key-${index}`} id={`tags-label-${index}`}>Tag</InputLabel>
                                    <Select
                                        id={`tags-${index}`}
                                        labelId={`tags-label-${index}`}
                                        multiple
                                        value={formTag.tags}
                                        onChange={(e) => handleTagsChange(e, index)}
                                        input={<OutlinedInput id={`tags-multiple-chip-${index}`} label="Tag" />}
                                        required
                                        renderValue={(selected) => (
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                {selected.map((value) => (
                                                    <Chip key={value} label={value} />
                                                ))}
                                            </Box>
                                        )}
                                    >
                                        {userDataState['tags'].map((tag) => (
                                            <MenuItem
                                                id={tag.id}
                                                key={`tags-chip-key-${tag.name}`}
                                                value={tag.name}
                                            >
                                                {tag.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <FormControl sx={{ m: 1, minWidth: 300 }}>
                                    <InputLabel id={`tags-label-input-${index}`}>Input Name</InputLabel>
                                    {tagsInputOptions(formTag, index)}
                                </FormControl>

                                <FormControl sx={{ m: 1, minWidth: 300 }}>
                                    <Autocomplete
                                        multiple
                                        freeSolo={(formTag.options && formTag.options.length > 0) ? false : true}
                                        id={`tags-values-${index}`}
                                        options={formTag.options ? formTag.options : []}
                                        value={formTag.values}
                                        inputValue={formTag.valuesInput}
                                        onInputChange={(e, inputValue) => {

                                            let currentFormTags = [...formTags];

                                            currentFormTags[index].valuesInput = inputValue;

                                            setFormTags(currentFormTags);

                                        }}
                                        onChange={(e, newValue) => {

                                            let currentFormTags = [...formTags];

                                            currentFormTags[index].values = newValue;

                                            setFormTags(currentFormTags);

                                        }}
                                        required
                                        filterSelectedOptions
                                        renderInput={params => {
                                            return (
                                                <TextField
                                                    ref={(e) => (tagsValuesRefs.current[index] = e)}
                                                    key={`tags-values-${index}`}
                                                    {...params}
                                                    variant="outlined"
                                                    label="Input Values"
                                                    placeholder="Add tag end press enter"
                                                    onBlur={(e, newValue) => {

                                                        e.preventDefault();
                                                        e.stopPropagation();

                                                        let currentFormTags = [...formTags];

                                                        const value = e.target.value;

                                                        if(value !== ''){
                                                            currentFormTags[index].values.push(value);
                                                            currentFormTags[index].valuesInput = '';
                                                        }

                                                        setFormTags(currentFormTags);

                                                    }}
                                                    onKeyDown={e => {

                                                        switch (e.key) {
                                                            case ",":
                                                            case " ": {
                                                                e.preventDefault();
                                                                e.stopPropagation();

                                                                let currentFormTags = [...formTags];

                                                                const value = e.target.value;

                                                                if(value !== ''){
                                                                    currentFormTags[index].values.push(value);
                                                                    currentFormTags[index].valuesInput = '';
                                                                }

                                                                setFormTags(currentFormTags);

                                                                break;
                                                            }
                                                            default:
                                                        }

                                                    }}
                                                    fullWidth
                                                />
                                            );
                                        }}
                                    />
                                </FormControl>

                                <FormControl sx={{ m: 1, minWidth: 300 }}>
                                    <TextField
                                        id={`tags-value-condition-${index}`}
                                        value={formTag.value_condition}
                                        label="Value Condition"
                                        select
                                        onChange={(e) => {

                                            e.preventDefault();

                                            let currentFormTags = [...formTags];

                                            currentFormTags[index].value_condition = e.target.value;

                                            setFormTags(currentFormTags);

                                        }}
                                    >
                                        <MenuItem value='equal'>Equal</MenuItem>
                                        <MenuItem value='not_equal'>Not Equal</MenuItem>
                                        <MenuItem value='has_string'>Has String</MenuItem>
                                        <MenuItem value='does_not_have_string'>Doesn`t Have String</MenuItem>
                                    </TextField>
                                </FormControl>

                            </ListItem>
                            <div style={{padding: '0px 15px 15px 25px'}}>
                                <Alert severity="info">
                                    <AlertTitle>Value condition</AlertTitle>
                                    <span dangerouslySetInnerHTML={{__html: valueConditions[formTag.value_condition]}} />
                                </Alert>
                            </div>
                            <Divider />
                        </div>
                    )}
                    <div key={`list-div-key-add`}>
                        <ListItem
                            sx={{justifyContent: 'center'}}
                            key={`list-key-add`}
                            onClick={(e) => {

                                e.preventDefault();

                                let currentFormTags = [...formTags];

                                currentFormTags.push({
                                    tags: [],
                                    tag_id: [],
                                    input: '',
                                    values: [],
                                    valuesInput: '',
                                    value_condition: 'equal'
                                });

                                setFormTags(currentFormTags);

                            }}
                            button
                        >
                            <AddIcon sx={{marginRight: 1}} /> <span>Add Form Input</span>
                        </ListItem>
                    </div>
                </List>
            </Dialog>

        }

    </>;

}